import React from "react";
import { connect, useSelector } from "react-redux";

import TopNav from "/@src/containers/navs/Topnav";
import Sidebar from "/@src/containers/navs/Sidebar";
import Footer from "/@src/containers/navs/Footer";

const AppLayout = ({ children }) => {
  const { containerClassnames } = useSelector(({ menu }) => menu);
  return (
    <div className="dashboard-wrapper">
      <div id="app-container" className={containerClassnames}>
        <TopNav />
        <Sidebar />
        <main>
          <div className="container">{children}</div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default AppLayout;
